import type { SVGProps } from 'react';

const SvgDriveFileMoveRtl = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M22 6H12l-2-2H2v16h20zM12 17l-4-4 4-4v3h4v2h-4z" />
  </svg>
);
export default SvgDriveFileMoveRtl;
